<template>
  <ItemPage
    :title="titlePage"
    size="md"
    :actions="actions"
  >
    <div v-if="group">
      <div v-if="group.choices.length > 0">
        <div class="font-weight-bold">
          Atenção
        </div>
        <div class="d-flex justify-space-between">
          <div class="d-flex text-body-2 text--secondary mt-1 my-2 align-center">
            Esta avaliação possui subgrupos, defina quantos subgrupos o aluno deverá escolher:
          </div>
          <div class="d-flex flex-row align-center text--secondary">
            <span
              v-if="!editChoicePick"
              class="mx-2"
            >
              Quantidade atual: {{ parseInt(group.choices_to_pick) }}
            </span>
            <v-text-field
              v-if="editChoicePick"
              v-model="choicePick"
              class="mx-5"
              style="min-width: 70px;"
              label="Quantidade"
              type="number"
              min="0"
              :max="group.choices.length"
            />
            <div class="d-flex flex-row justify-center">
              <v-btn
                v-if="!editChoicePick"
                class="mx-1"
                outlined
                small
                fab
                color="primary"
                @click="editChoicePick = !editChoicePick"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn
                v-if="editChoicePick"
                class="mx-1"
                outlined
                color="primary"
                @click="updateQuestionGroups"
              >
                salvar
              </v-btn>
            </div>
          </div>
        </div>
      </div>
      <ExamChoiceGroups
        :group="group"
        @reload="getQuestionGroups"
      />
      <QuestionsList
        :id-group="parseInt(groupId)"
      />
    </div>
  </ItemPage>
</template>

<script>
import handlesServerValidation from '@/mixins/handles-server-validation.js'
import QuestionsList from './components/QuestionsList.vue'
import ItemPage from '@/components/pages/ItemPage.vue'
import ExamChoiceGroups from './components/ExamChoiceGroups.vue'

export default {
  components: {
    QuestionsList,
    ItemPage,
    ExamChoiceGroups
  },

  mixins: [
    handlesServerValidation
  ],

  data () {
    return {
      choicePick: 0,
      editChoicePick: false,
      exam: null,
      group: null,
      loading: false,
      titlePage: 'Grupo de questões'
    }
  },

  computed: {
    examId () {
      return this.$route.params.examId
    },
    groupId () {
      return this.$route.params.groupId
    },

    actions () {
      return [
        // {
        //   label: 'Adicionar questão',
        //   action: () => this.openNewQuestionDialog(),
        //   icon: 'mdi-plus',
        //   disabled: true
        //   // disabled: this.published ? this.published : this.loading
        // },
        // {
        //   label: 'Atualizar',
        //   action: this.updateQuestionsGroup,
        //   icon: 'mdi-floppy',
        //   disabled: this.questionsUpdate ? this.questionsUpdate : this.disableUpdate ? this.disableUpdate : this.loading
        // },
        // {
        //   label: 'Deletar',
        //   action: this.deleteQuestionsGroup,
        //   icon: 'mdi-delete',
        //   disabled: this.questionsDelete ? this.questionsDelete : this.published ? this.published : this.loading
        // }
      ]
    }
  },
  watch: {
    title () {
      this.checkUpdate()
    },
    caption () {
      this.checkUpdate()
    }
  },
  async mounted () {
    this.fetchAll()
  },
  methods: {
    async fetchAll () {
      await this.getExams()
      await this.getQuestionGroups()
    },

    async getExams () {
      this.loading = true
      try {
        this.exam = await this.$api.getExams(this.examId)
      } catch (e) {
        this.$store.dispatch('setSnackBar', { text: 'Erro ao tentar obter avaliação.', color: 'red' })
        this.getErrors(e)
      } finally {
        this.loading = false
      }
    },

    async getQuestionGroups () {
      this.loading = true
      try {
        this.group = await this.$api.getQuestionGroups(this.groupId)
        this.choicePick = this.group.choices_to_pick
        this.titlePage = 'Grupo: ' + this.group.title
      } catch (e) {
        this.$store.dispatch('setSnackBar', { text: 'Erro ao tentar obter grupo de questões.', color: 'red' })
        this.getErrors(e)
      } finally {
        this.loading = false
      }
    },
    async updateQuestionGroups () {
      const data = {
        choices_to_pick: this.choicePick
      }
      this.loading = true
      try {
        await this.$api.updateQuestionGroups(this.groupId, data)
        this.$store.dispatch('setSnackBar', { text: 'Grupo atualizado.' })
        this.editChoicePick = false
        await this.getQuestionGroups()
      } catch (e) {
        this.$store.dispatch('setSnackBar', { text: 'Erro ao tentar salvar grupo de questões.', color: 'red' })
        this.getErrors(e)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
